import api from "./axios";

// ============================================================
// LIST EXPENSES
// ============================================================

export const getExpenses = async (page = 1, limit = 10, filters = {}) => {

     console.log("[API] getExpenses called", { page, limit, filters });    

    const response = await api.get("/expenses", {
        params: {
            page,
            limit,
            ...filters,
        },
    });

    return response.data;
};

// ============================================================
// GET SINGLE EXPENSE
// ============================================================

export const getExpense = async (id) => {
    const response = await api.get(`/expenses/${id}`);
    return response.data;
};

// ============================================================
// CREATE EXPENSE
// ============================================================

export const createExpense = async (data) => {
    const response = await api.post("/expenses", data);
    return response.data;
};

// ============================================================
// UPDATE EXPENSE
// Normal expense fields only.
// Do not send teamLeaderRemark/adminRemark through this API.
// ============================================================

export const updateExpense = async (id, data) => {
    const response = await api.patch(`/expenses/${id}`, data);
    return response.data;
};

// ============================================================
// UPDATE TEAM LEADER REMARK
// ============================================================

export const updateTeamLeaderRemark = async (id, remark) => {
    const response = await api.patch(
        `/expenses/${id}/team-leader-remark`,
        { remark }
    );

    return response.data;
};

// ============================================================
// UPDATE ADMIN REMARK
// ============================================================

export const updateAdminRemark = async (id, remark) => {
    const response = await api.patch(
        `/expenses/${id}/admin-remark`,
        { remark }
    );

    return response.data;
};

// ============================================================
// SUBMIT EXPENSE
// ============================================================

export const submitExpense = async (id) => {
    const response = await api.post(`/expenses/${id}/submit`);
    return response.data;
};

// ============================================================
// APPROVE EXPENSE - ADMIN ONLY
// ============================================================

export const approveExpense = async (id, data) => {
    const response = await api.post(`/expenses/${id}/approve`, data);
    return response.data;
};

// ============================================================
// REJECT EXPENSE
// ============================================================

export const rejectExpense = async (id, reason) => {
    const response = await api.post(`/expenses/${id}/reject`, {
        reason,
    });

    return response.data;
};

// ============================================================
// MARK EXPENSE AS PAID
// ============================================================

export const markExpensePaid = async (id, data = {}) => {
    const response = await api.post(
        `/expenses/${id}/mark-paid`,
        data
    );

    return response.data;
};

// ============================================================
// DELETE / CANCEL EXPENSE
// ============================================================

export const deleteExpense = async (id) => {
    const response = await api.delete(`/expenses/${id}`);
    return response.data;
};

// ============================================================
// EXPENSE PRINT / TA-DA REPORT
// ============================================================

export const getExpensePrintReport = async (id) => {
    const response = await api.get(`/expenses/${id}/print`);
    return response.data;
};

export const updateApprovedAmountByAdmin = (id, data) =>
  api.patch(`/expenses/${id}/approved-amount`, data);

// ============================================================
// UPLOAD EXPENSE RECEIPT
// ============================================================

export const uploadExpenseReceipt = async (file) => {
    const formData = new FormData();

    formData.append("file", file);
    formData.append("folder", "expenses");

    const response = await api.post("/uploads", formData, {
        headers: {
            "Content-Type": undefined,
        },
    });

     console.log("Expense receipt upload response:", response.data);

    return response.data;
};